import { NEWSLETTER_MESSAGES } from "@config/newsletter";
import fetchBHApi from "@helper/fetchBHApi";
import { getValidEmailRegex } from "@helper/utils";
import { NewsletterPostResponse } from "@typings/Newsletter";
import cx from "classnames";
import type { ReactElement } from "react";
import { FormEvent, useState } from "react";

import styles from "./NewsletterUnsubscribeForm.module.css";

type Props = Readonly<{
  testId?: string;
}>;
export default function UnsubscribeForm({
  testId = "newsletter-form",
}: Props): ReactElement {
  const [email, setEmail] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [successMsg, setSuccessMsg] = useState<string>("");

  async function handleOnSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    e.stopPropagation();
    // validate email
    if (
      email &&
      getValidEmailRegex().test(email) // Valid email format
    ) {
      try {
        const res = await fetchBHApi("newsletterUnSubscribe", "POST", {
          email,
        });
        const data = (await res) as NewsletterPostResponse;
        if (data.msg) {
          setErrorMsg(""); // unset error message
          setSuccessMsg(data.msg);
          return;
        }

        if (data.errorMsg) {
          setErrorMsg(data.errorMsg);
          return;
        }
      } catch (e: unknown) {
        setErrorMsg(NEWSLETTER_MESSAGES.FAILED);
        return;
      }
    } else {
      // Invalid email
      setErrorMsg(NEWSLETTER_MESSAGES.INVALID_EMAIL);
      return;
    }
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value);
  }

  return (
    <form
      onSubmit={(e: FormEvent<HTMLFormElement>) => void handleOnSubmit(e)}
      data-testid={testId}
      className="mb-md"
    >
      <div
        className={cx(
          errorMsg || successMsg ? styles.alert : "",
          errorMsg ? styles.alertError : successMsg ? styles.alertSuccess : "",
        )}
      >
        {errorMsg || successMsg}
      </div>
      <div className={styles.formGroup}>
        <input
          onChange={handleInputChange}
          type="email"
          className={styles.formControl}
          placeholder="Enter your email address"
        />
      </div>
      <button
        className={styles.btnNewsletter}
        aria-label="Unsubscribe from Newsletter"
      >
        Unsubscribe
      </button>
    </form>
  );
}
